export default __webpack_public_path__ + "static/media/angular.9ea9a69e.jpg";